"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferBase = void 0;
const tslib_1 = require("tslib");
const BaseProposition_1 = tslib_1.__importDefault(require("./propositions/BaseProposition"));
const class_validator_1 = require("class-validator");
const base_models_1 = require("@integration/base-models");
const class_transformer_1 = require("class-transformer");
const GetNextBestOfferResponseOfferIncentiveV2_1 = tslib_1.__importDefault(require("./offers/v2/GetNextBestOfferResponseOfferIncentiveV2"));
const PropositionDuration_1 = tslib_1.__importDefault(require("./enums/PropositionDuration"));
class OfferBase extends BaseProposition_1.default {
}
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsUUID)(),
    (0, base_models_1.Docs)({
        example: '4db7554c-e5cc-4c31-82b0-8bc7d134c0f7',
        description: 'Profile identifier',
    }),
    tslib_1.__metadata("design:type", String)
], OfferBase.prototype, "offerId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsIn)(Object.values(PropositionDuration_1.default)),
    (0, base_models_1.Docs)({
        example: PropositionDuration_1.default.FLEX,
        description: 'Proposition duration.',
    }),
    tslib_1.__metadata("design:type", String)
], OfferBase.prototype, "duration", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNumber)(),
    (0, base_models_1.Docs)({ example: 4, description: 'Offer ranking' }),
    tslib_1.__metadata("design:type", Number)
], OfferBase.prototype, "ranking", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => GetNextBestOfferResponseOfferIncentiveV2_1.default),
    tslib_1.__metadata("design:type", Array)
], OfferBase.prototype, "incentives", void 0);
exports.OfferBase = OfferBase;
